import BaseService from "./baseServices";
import { RouteConstants } from "./RouteConstants";
import { Profile } from "../types";

const toProfile = (me: any): Profile => ({
  ...me,
  name: [me?.first_name, me?.last_name].filter(Boolean).join(" "),
});

export const fetchMyProfile = async (): Promise<Profile> => {
  const res = await BaseService.get_api(RouteConstants.ME);
  return toProfile(res.data?.payload);
};

export const updateMyProfile = async (data: {
  first_name?: string;
  last_name?: string;
  email?: string;
}): Promise<Profile> => {
  const res = await BaseService.put_api(RouteConstants.MY_PROFILE, data);
  return toProfile(res.data?.payload);
};
